(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sd-bestsellers-showcase"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('sd-bestsellers')) {
  customElements.define('sd-bestsellers', class extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.track = this.querySelector('.sdb__track');
      this.arrows = [...this.querySelectorAll('[data-direction]')];
      this.addEventListener('submit', event => {
        const form = event.target.closest('.sdb__cart-form');
        if (!form) return;
        event.preventDefault();
        this.addToCart(form);
      }, {signal});
      const update = () => {
        const media = this.track.querySelector('.sdb__media');
        if (media) this.style.setProperty('--sdb-arrow-top', (media.offsetHeight / 2 + 7) + 'px');
        const max = this.track.scrollWidth - this.track.clientWidth;
        this.arrows.forEach(button => {
          button.hidden = max < 3;
          button.disabled = Number(button.dataset.direction) < 0 ? this.track.scrollLeft < 3 : this.track.scrollLeft >= max - 3;
        });
      };
      this.arrows.forEach(button => button.addEventListener('click', () => {
        const card = this.track.querySelector('.sdb__card');
        if (card) this.track.scrollBy({left: Number(button.dataset.direction) * (card.getBoundingClientRect().width + parseFloat(getComputedStyle(this.track).gap)), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
      }, {signal}));
      this.track.addEventListener('scroll', update, {passive: true, signal});
      this.observer = new ResizeObserver(update);
      this.observer.observe(this.track);
      this.querySelectorAll('[data-favourite]').forEach(button => {
        const key = 'salford-favourite-' + button.dataset.favourite;
        try { button.setAttribute('aria-pressed', localStorage.getItem(key) === 'true' ? 'true' : 'false'); } catch {}
        button.addEventListener('click', () => {
          const next = button.getAttribute('aria-pressed') !== 'true';
          document.querySelectorAll('sd-bestsellers [data-favourite="' + button.dataset.favourite + '"]').forEach(item => item.setAttribute('aria-pressed', String(next)));
          try { localStorage.setItem(key, String(next)); } catch {}
        }, {signal});
      });
      update();
    }
    async addToCart(form) {
      if (this.constructor.cartPending) return;
      const button = form.querySelector('[type="submit"]');
      const error = form.querySelector('.sdb__cart-error');
      const drawer = document.querySelector('cart-drawer');
      error.hidden = true;
      if (!drawer || typeof drawer.renderContents !== 'function') {
        error.textContent = this.dataset.cartError;
        error.hidden = false;
        return;
      }
      this.constructor.cartPending = true;
      const buttons = [...document.querySelectorAll('sd-bestsellers .sdb__cart-form [type="submit"]')].filter(item => !item.disabled);
      buttons.forEach(item => { item.disabled = true; });
      button.setAttribute('aria-busy', 'true');
      let added = false;
      try {
        const sections = drawer.getSectionsToRender().map(section => section.id);
        const body = new FormData(form);
        body.set('sections', sections.join(','));
        body.set('sections_url', window.location.pathname);
        drawer.setActiveElement(button);
        const response = await fetch(this.dataset.addUrl, {
          method: 'POST',
          headers: {Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest'},
          body
        });
        const result = await response.json();
        if (!response.ok || result.status) throw new Error(result.description || this.dataset.cartError);
        added = true;
        if (!sections.every(id => typeof result.sections?.[id] === 'string')) {
          const url = new URL(window.location.href);
          url.searchParams.set('sections', sections.join(','));
          const refreshed = await fetch(url, {headers: {Accept: 'application/json'}});
          if (!refreshed.ok) throw new Error(this.dataset.cartRefreshError);
          result.sections = await refreshed.json();
          if (!sections.every(id => typeof result.sections?.[id] === 'string')) throw new Error(this.dataset.cartRefreshError);
        }
        drawer.classList.remove('is-empty');
        drawer._closedByUser = false;
        drawer.renderContents(result);
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          Promise.resolve(publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'product-form', productVariantId: body.get('id'), cartData: result
          })).catch(() => {});
        }
      } catch (failure) {
        error.textContent = added ? this.dataset.cartRefreshError : (failure.message || this.dataset.cartError);
        error.hidden = false;
      } finally {
        buttons.forEach(item => { item.disabled = false; });
        button.removeAttribute('aria-busy');
        this.constructor.cartPending = false;
      }
    }
    disconnectedCallback() { this.controller?.abort(); this.observer?.disconnect(); }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sd-cocktail-recipes"] && !Shopify.designMode) return;
  try {
    
(() => {
  const visibleCards = root => [...root.querySelectorAll('.sd-cocktails__card')].filter(card => !card.hidden);
  function updateDots(root) {
    const track = root.querySelector('.sd-cocktails__track');
    const cards = visibleCards(root);
    if (!cards.length) return;
    const left = track.getBoundingClientRect().left + parseFloat(getComputedStyle(track).paddingLeft || 0);
    const nearest = cards.reduce((best, card, index) => Math.abs(card.getBoundingClientRect().left - left) < Math.abs(cards[best].getBoundingClientRect().left - left) ? index : best, 0);
    root.querySelectorAll('.sd-cocktails__dot').forEach((dot, index) => {
      dot.classList.toggle('is-active', index === nearest);
      if (index === nearest) dot.setAttribute('aria-current', 'true');
      else dot.removeAttribute('aria-current');
    });
  }
  function filter(root, key, announce = true) {
    root.querySelectorAll('.sd-cocktails__card').forEach(card => {
      card.hidden = Boolean(key && card.dataset.bottleKey !== key);
    });
    root.querySelectorAll('[data-sd-cocktail-filter]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.sdCocktailFilter === key)));
    const cards = visibleCards(root);
    const selection = root.querySelector('.sd-cocktails__selection');
    const selectedLabel = key ? cards[0]?.dataset.bottleLabel : '';
    selection.hidden = !selectedLabel;
    selection.querySelector('h3').textContent = selectedLabel || '';
    const shop = selection.querySelector('.sd-cocktails__bottle-shop');
    if (shop) {
      const urls = [...new Set(cards.map(card => card.dataset.bottleUrl).filter(Boolean))];
      const url = key && urls.length === 1 ? urls[0] : '';
      shop.hidden = !url;
      shop.textContent = url ? shop.dataset.shopPrefix + ' ' + selectedLabel : '';
      if (url) shop.setAttribute('href', url);
      else shop.removeAttribute('href');
    }
    const dots = root.querySelector('.sd-cocktails__dots');
    dots.replaceChildren();
    cards.forEach((card, index) => {
      const dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'sd-cocktails__dot';
      dot.setAttribute('aria-label', dots.dataset.slideLabel + ' ' + (index + 1));
      dot.addEventListener('click', () => {
        const track = root.querySelector('.sd-cocktails__track');
        const offset = card.getBoundingClientRect().left - track.getBoundingClientRect().left - parseFloat(getComputedStyle(track).paddingLeft || 0);
        track.scrollTo({ left: track.scrollLeft + offset, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
      });
      dots.append(dot);
    });
    dots.hidden = cards.length < 2;
    root.querySelector('.sd-cocktails__track').scrollLeft = 0;
    if (announce) {
      const status = root.querySelector('.sd-cocktails__status');
      status.textContent = status.dataset.countLabel + ' ' + cards.length;
    }
    updateDots(root);
  }
  function init(root) {
    if (root.dataset.sdCocktailReady) return;
    root.dataset.sdCocktailReady = 'true';
    const filters = root.querySelector('.sd-cocktails__filters');
    const groups = new Map();
    root.querySelectorAll('[data-bottle-key]').forEach(card => {
      if (card.dataset.bottleLabel) groups.set(card.dataset.bottleKey, card.dataset.bottleLabel);
    });
    groups.forEach((label, key) => {
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'sd-cocktails__filter';
      button.dataset.sdCocktailFilter = key;
      button.textContent = label;
      button.setAttribute('aria-pressed', 'false');
      filters.append(button);
    });
    filters.querySelectorAll('[data-sd-cocktail-filter]').forEach(button => {
      const key = button.dataset.sdCocktailFilter;
      const count = [...root.querySelectorAll('[data-bottle-key]')].filter(card => !key || card.dataset.bottleKey === key).length;
      const badge = document.createElement('span');
      badge.className = 'sd-cocktails__filter-count';
      badge.setAttribute('aria-hidden', 'true');
      badge.textContent = count;
      button.append(badge);
    });
    filters.hidden = groups.size === 0;
    root.querySelector('.sd-cocktails__filter-panel').hidden = groups.size === 0;
    filters.addEventListener('click', event => {
      const button = event.target.closest('[data-sd-cocktail-filter]');
      if (button) filter(root, button.dataset.sdCocktailFilter);
    });
    root.querySelector('.sd-cocktails__track').addEventListener('scroll', () => updateDots(root), { passive: true });
    root.querySelectorAll('dialog').forEach(dialog => {
      dialog.addEventListener('close', () => dialog._sdCocktailTrigger?.focus());
      dialog.addEventListener('click', event => {
        if (event.target !== dialog) return;
        const rect = dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
      });
    });
    filter(root, '', false);
  }
  function scan(scope) {
    if (scope.matches?.('.sd-cocktails')) init(scope);
    scope.querySelectorAll('.sd-cocktails').forEach(init);
  }
  document.addEventListener('click', event => {
    const opener = event.target.closest('[data-sd-cocktail-open]');
    if (opener) {
      const dialog = document.getElementById(opener.dataset.sdCocktailOpen);
      if (dialog && !dialog.open) {
        dialog._sdCocktailTrigger = opener;
        dialog.showModal();
      }
    }
    event.target.closest('[data-sd-cocktail-close]')?.closest('dialog')?.close();
  });
  document.addEventListener('shopify:section:load', event => scan(event.target));
  document.addEventListener('shopify:block:select', event => {
    const root = event.target.closest('.sd-cocktails');
    if (!root) return;
    if (event.target.hidden) filter(root, '');
    event.target.scrollIntoView({ block: 'nearest', inline: 'nearest' });
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => scan(document));
  else scan(document);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sd-experiences-showcase"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', event => {
  const dot = event.target.closest('[data-sd-exp-dot]');
  if (!dot) return;
  const track = document.getElementById(dot.dataset.sdExpTrack);
  const card = track?.querySelectorAll('.sd-exp-showcase__card')[Number(dot.dataset.sdExpDot)];
  card?.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
});
document.addEventListener('scroll', event => {
  const track = event.target;
  if (!track.classList?.contains('sd-exp-showcase__track')) return;
  const cards = [...track.querySelectorAll('.sd-exp-showcase__card')];
  if (!cards.length) return;
  const nearest = cards.reduce((best, card, index) => Math.abs(card.offsetLeft - track.scrollLeft) < Math.abs(cards[best].offsetLeft - track.scrollLeft) ? index : best, 0);
  track.closest('.sd-exp-showcase')?.querySelectorAll('.sd-exp-showcase__dot').forEach((dot, index) => {
    dot.classList.toggle('is-active', index === nearest);
    if (index === nearest) dot.setAttribute('aria-current', 'true');
    else dot.removeAttribute('aria-current');
  });
}, true);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sd-home-bundle"] && !Shopify.designMode) return;
  try {
    
function initSDHomeBundles() {
  document.querySelectorAll('[data-sd-home-bundle]').forEach(root => {
    if (root.dataset.sdBundleReady === 'true') return;
    root.dataset.sdBundleReady = 'true';
    const form = root.querySelector('[data-sd-bundle-form]');
    if (!form) return;
    const options = [...form.querySelectorAll('[data-sd-bundle-option]')];
    const input = form.querySelector('[data-sd-bundle-variant-id]');
    const submit = form.querySelector('[data-sd-bundle-submit]');
    const message = form.querySelector('[data-sd-bundle-message]');
    const quantity = form.querySelector('[data-sd-bundle-quantity]');
    let controller;
    let resolving = false;
    let adding = false;

    function setMessage(value) { message.textContent = value || ''; }
    function setButtonState() { submit.disabled = resolving || adding || !input.value || root.dataset.variantAvailable !== 'true'; }
    function clampQuantity() { quantity.value = Math.max(1, Math.min(20, Number(quantity.value) || 1)); }

    form.querySelector('[data-sd-bundle-minus]')?.addEventListener('click', () => { clampQuantity(); quantity.value = Math.max(1, Number(quantity.value) - 1); });
    form.querySelector('[data-sd-bundle-plus]')?.addEventListener('click', () => { clampQuantity(); quantity.value = Math.min(20, Number(quantity.value) + 1); });
    quantity.addEventListener('change', clampQuantity);

    function readSelectedVariant(markup) {
      const html = new DOMParser().parseFromString(markup, 'text/html');
      const node = html.querySelector('oct-three-bundle script[data-state]') || html.querySelector('script[data-selected-variant]');
      if (!node) return { variant: undefined, html };
      try {
        const data = JSON.parse(node.textContent || 'null');
        return { variant: node.hasAttribute('data-state') ? data?.variant : data, html };
      }
      catch { return { variant: undefined, html }; }
    }

    function matchesSelection(variant) {
      return variant && Array.isArray(variant.options) && variant.options.length === options.length && variant.options.every((value, index) => value === options[index]?.selectedOptions[0]?.textContent.trim());
    }

    async function resolveVariant() {
      controller?.abort();
      const requestController = new AbortController();
      controller = requestController;
      resolving = true;
      input.value = '';
      setMessage('Checking your bottle combination…');
      setButtonState();
      try {
        const values = options.map(select => select.value).join(',');
        const url = new URL(root.dataset.productUrl, window.location.origin);
        url.searchParams.set('option_values', values);
        let resolved;
        if (root.dataset.productSectionId) {
          const sectionUrl = new URL(url);
          sectionUrl.searchParams.set('section_id', root.dataset.productSectionId);
          const sectionResponse = await fetch(sectionUrl, { signal: requestController.signal, credentials: 'same-origin' });
          if (sectionResponse.ok) resolved = readSelectedVariant(await sectionResponse.text()).variant;
        }
        if (!matchesSelection(resolved)) {
          const productResponse = await fetch(url, { signal: requestController.signal, credentials: 'same-origin' });
          if (!productResponse.ok) throw new Error('Unable to check this combination. Please try again.');
          const productMarkup = readSelectedVariant(await productResponse.text());
          resolved = productMarkup.variant;
          const mainSection = productMarkup.html.querySelector('[id^="shopify-section-template--"][id$="__main"]');
          if (mainSection) root.dataset.productSectionId = mainSection.id.replace('shopify-section-', '');
        }
        if (!matchesSelection(resolved)) throw new Error('That bottle combination is unavailable. Please choose another.');
        input.value = resolved.id || '';
        root.dataset.variantAvailable = resolved.available ? 'true' : 'false';
        setMessage(input.value && root.dataset.variantAvailable === 'true' ? '' : 'That bottle combination is unavailable. Please choose another.');
      } catch (error) {
        if (error.name === 'AbortError') return;
        root.dataset.variantAvailable = 'false';
        setMessage(error.message || 'Unable to check this combination. Please try again.');
      } finally {
        if (controller === requestController && !requestController.signal.aborted) { resolving = false; setButtonState(); }
      }
    }

    options.forEach(select => select.addEventListener('change', resolveVariant));
    form.addEventListener('submit', async event => {
      event.preventDefault();
      if (resolving || adding || !input.value || root.dataset.variantAvailable !== 'true') return;
      clampQuantity();
      adding = true;
      setButtonState();
      setMessage('Adding your bundle…');
      try {
        const drawer = document.querySelector('cart-drawer');
        const cartData = new FormData();
        cartData.append('id', input.value);
        cartData.append('quantity', quantity.value);
        if (drawer?.getSectionsToRender) {
          cartData.append('sections', drawer.getSectionsToRender().map(section => section.id));
          cartData.append('sections_url', window.location.pathname);
          drawer.setActiveElement?.(document.activeElement);
        }
        const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
          method: 'POST',
          headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: cartData
        });
        const result = await response.json();
        if (!response.ok || result.status) throw new Error(result.description || 'Unable to add this bundle.');
        setMessage('Added to your basket.');
        if (drawer?.renderContents && result.sections) {
          drawer.classList.remove('is-empty');
          drawer.renderContents(result);
        }
        else if (drawer?.open) drawer.open();
        else window.location.href = window.routes?.cart_url || '/cart';
      } catch (error) {
        setMessage(error.message || 'Unable to add this bundle.');
      } finally {
        adding = false;
        setButtonState();
      }
    });
    resolveVariant();
  });
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initSDHomeBundles);
else initSDHomeBundles();
document.addEventListener('shopify:section:load', initSDHomeBundles);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sd-journal-showcase"] && !Shopify.designMode) return;
  try {
    
function initSDJournalShowcases() {
  document.querySelectorAll('[data-sd-journal]').forEach(root => {
    if (root.dataset.sdJournalReady === 'true') return;
    root.dataset.sdJournalReady = 'true';
    const track = root.querySelector('.sd-journal__track');
    const cards = [...track.querySelectorAll('.sd-journal__card')];
    const controls = root.querySelector('[data-sd-journal-controls]');
    const dotsWrap = root.querySelector('[data-sd-journal-dots]');
    const prev = root.querySelector('[data-sd-journal-prev]');
    const next = root.querySelector('[data-sd-journal-next]');
    if (cards.length < 2) return;
    controls.hidden = false;
    let active = 0;
    const dots = cards.map((card, index) => {
      const dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'sd-journal__dot';
      dot.setAttribute('aria-label', `${root.dataset.dotLabel || 'Show article'} ${index + 1}`);
      dot.addEventListener('click', () => goTo(index));
      dotsWrap.appendChild(dot);
      return dot;
    });
    function update() {
      const first = cards[0].offsetLeft;
      const nearest = cards.reduce((best, card, index) => Math.abs(card.offsetLeft - first - track.scrollLeft) < Math.abs(cards[best].offsetLeft - first - track.scrollLeft) ? index : best, 0);
      active = nearest;
      dots.forEach((dot, index) => {
        dot.classList.toggle('is-active', index === nearest);
        if (index === nearest) dot.setAttribute('aria-current', 'true');
        else dot.removeAttribute('aria-current');
      });
      prev.disabled = nearest === 0;
      next.disabled = nearest === cards.length - 1;
    }
    function goTo(index) {
      const destination = Math.max(0, Math.min(cards.length - 1, index));
      track.scrollTo({ left: cards[destination].offsetLeft - cards[0].offsetLeft, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
    }
    prev.addEventListener('click', () => goTo(active - 1));
    next.addEventListener('click', () => goTo(active + 1));
    track.addEventListener('scroll', () => requestAnimationFrame(update), { passive: true });
    window.addEventListener('resize', update, { passive: true });
    update();
  });
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initSDJournalShowcases);
else initSDJournalShowcases();
document.addEventListener('shopify:section:load', initSDJournalShowcases);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sd-recipe-showcase"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', event => {
  const opener = event.target.closest('[data-sd-recipe-open]');
  if (opener) {
    const dialog = document.getElementById(opener.dataset.sdRecipeOpen);
    if (dialog && typeof dialog.showModal === 'function') {
      dialog._sdRecipeTrigger = opener;
      dialog.showModal();
    }
    return;
  }
  const close = event.target.closest('[data-sd-recipe-close]');
  if (close) {
    close.closest('dialog')?.close();
    return;
  }
  const dot = event.target.closest('[data-sd-recipe-dot]');
  if (dot) {
    const track = document.getElementById(dot.dataset.sdRecipeTrack);
    const card = track?.querySelectorAll('.sd-recipes__card')[Number(dot.dataset.sdRecipeDot)];
    card?.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
    return;
  }
  if (event.target.matches('.sd-recipes__dialog')) event.target.close();
});
document.addEventListener('close', event => {
  if (event.target.matches('.sd-recipes__dialog')) event.target._sdRecipeTrigger?.focus();
}, true);
document.addEventListener('scroll', event => {
  const track = event.target;
  if (!track.classList?.contains('sd-recipes__track')) return;
  const cards = [...track.querySelectorAll('.sd-recipes__card')];
  if (!cards.length) return;
  const nearest = cards.reduce((best, card, index) => Math.abs(card.offsetLeft - track.scrollLeft) < Math.abs(cards[best].offsetLeft - track.scrollLeft) ? index : best, 0);
  track.closest('.sd-recipes')?.querySelectorAll('.sd-recipes__dot').forEach((dot, index) => {
    dot.classList.toggle('is-active', index === nearest);
    if (index === nearest) dot.setAttribute('aria-current', 'true');
    else dot.removeAttribute('aria-current');
  });
}, true);

  } catch(e) { console.error(e); }
})();
})();
